import * as React from 'react';
import * as styles from './index.css';
import { ITrackingReducerState } from '../../store/tracking';

export const DEFAULT_DEPOSIT_PERCENTAGES = 35;
export const DEFAULT_TERM = 20;

export interface IMortgageCalculatorProps {
  tracking: ITrackingReducerState;
  mortgageWidgetMarkup?: string;
}

export const MortgageCalculator = (props: IMortgageCalculatorProps) => {
  const {mortgageWidgetMarkup} = props;

  if (!mortgageWidgetMarkup) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div dangerouslySetInnerHTML={{__html: mortgageWidgetMarkup}}/>
    </div>
  );
};
